import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Sparkles, ArrowRight } from "lucide-react";
import { FAQS, CAMPAIGNS, buildWhatsAppLink } from "@/data/site";

export default function FaqAndCampaigns() {
  return (
    <section
      data-testid="faq-campaigns-section"
      className="relative py-24 lg:py-32 bg-[#050A1F] overflow-hidden"
    >
      <div className="absolute inset-0 bg-blueprint opacity-25 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12">
        {/* FAQ */}
        <div className="lg:col-span-7">
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
            Sık Sorulan Sorular
          </p>
          <h2 className="font-display text-4xl sm:text-5xl font-bold mb-10 text-balance">
            <span className="text-gradient-silver">Aklınızda </span>
            <span className="text-gradient-gold">soru kalmasın.</span>
          </h2>

          <Accordion
            type="single"
            collapsible
            className="w-full space-y-3"
            data-testid="faq-accordion"
          >
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="glass rounded-xl border border-white/10 px-5 hover:border-gold/40 transition-colors"
              >
                <AccordionTrigger className="text-left text-white font-medium text-base hover:text-gold no-underline hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/65 text-sm leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Campaigns */}
        <div className="lg:col-span-5">
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-3">
            Kampanyalar
          </p>
          <h2 className="font-display text-4xl sm:text-5xl font-bold mb-10 text-balance">
            <span className="text-gradient-silver">Aktif </span>
            <span className="text-gradient-gold">fırsatlar.</span>
          </h2>

          <div className="space-y-4">
            {CAMPAIGNS.map((c, i) => {
              const isBlue = c.accent === "blue";
              return (
                <div
                  key={c.title}
                  data-testid={`campaign-${i}`}
                  className={`relative card-lift rounded-2xl p-6 overflow-hidden ${
                    isBlue
                      ? "glass-blue hover:border-inci-blue"
                      : "glass-gold hover:border-gold"
                  }`}
                >
                  <div
                    className={`absolute -top-10 -right-10 w-40 h-40 rounded-full blur-3xl ${
                      isBlue ? "bg-inci-blue/30" : "bg-gold/20"
                    }`}
                  />
                  <div className="relative">
                    <div
                      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.2em] font-bold mb-4 ${
                        isBlue
                          ? "bg-inci-blue/20 text-inci-blue border border-inci-blue/40"
                          : "bg-gold/20 text-gold border border-gold/40"
                      }`}
                    >
                      <Sparkles className="w-3 h-3" />
                      {c.badge}
                    </div>
                    <h3 className="font-display font-semibold text-xl text-white mb-2">
                      {c.title}
                    </h3>
                    <p className="text-white/65 text-sm leading-relaxed mb-5">
                      {c.text}
                    </p>
                    <a
                      href={buildWhatsAppLink(
                        `Merhaba, "${c.title}" kampanyası hakkında bilgi almak istiyorum.`
                      )}
                      target="_blank"
                      rel="noreferrer"
                      className={`inline-flex items-center gap-1.5 text-sm font-semibold ${
                        isBlue ? "text-inci-blue hover:text-inci-blue-light" : "text-gold hover:text-gold-light"
                      } transition-colors`}
                    >
                      {c.cta} <ArrowRight className="w-4 h-4" />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
